package diana.soleil.design.iraniancanadienbazzar.feature.business

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.waitForUpOrCancellation
import androidx.compose.foundation.layout.Box
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.DeferredContent
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.style.TextAlign
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.runtime.collectAsState
import diana.soleil.design.iraniancanadienbazzar.core.common.AnalyticsEvents
import diana.soleil.design.iraniancanadienbazzar.core.common.ShareService
import diana.soleil.design.iraniancanadienbazzar.core.data.FeatureFlags
import diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig
import diana.soleil.design.iraniancanadienbazzar.core.model.Address
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ActionButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReviewCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportReason
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportStatus
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.FullScreenImageViewer
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.data.DealsRepository
import diana.soleil.design.iraniancanadienbazzar.core.common.DataResult
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.RatingStars
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.MapPin
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.MapPoint
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppMap
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.VerificationBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.StatusBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.model.Business
import diana.soleil.design.iraniancanadienbazzar.core.model.BusinessAttributeRegistry
import diana.soleil.design.iraniancanadienbazzar.core.model.categoryIconKey
import diana.soleil.design.iraniancanadienbazzar.core.model.Language
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.core.model.localizeDigits
import diana.soleil.design.iraniancanadienbazzar.core.model.ClaimStatus
import diana.soleil.design.iraniancanadienbazzar.core.model.ListingMetric
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_endorsements
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_empty
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_no_reviews_header
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_review_nudge_title
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_review_nudge_desc
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_review_nudge_dismiss_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_error
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_retry
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_action_call
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_action_chat
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_action_directions
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_action_see_all
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_action_website
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_claim_cta
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_claim_desc
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_claim_title
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_claim_verified_cta
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_claim_verified_desc
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_claim_verified_title
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_closed
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_cover_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_open_now
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_photo_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.photo_viewer_close_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.photo_viewer_counter
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_address_approx
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_listing_request_link
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_rating_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_report
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_save_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_channel
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_follow
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_following
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_saved_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_section_about
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_section_amenities
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_section_hours
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.map_attribution
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.biz_lang_arabic
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.biz_lang_english
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.biz_lang_french
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.biz_lang_persian
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_section_photos
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_owner_reply
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_reviews_empty
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_section_reviews
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_share_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_share_message
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_done
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_failed
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_reason_closed
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_reason_incorrect
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_reason_offensive
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_reason_scam
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_sent
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_sheet_title
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_submit
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_verified_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_pro_badge
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_write_review
import org.jetbrains.compose.resources.pluralStringResource
import kotlin.math.roundToInt
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

/**
 * Stateful entry for business detail: resolves [BusinessDetailViewModel] (scoped to [businessId])
 * from Koin and renders the stateless screen.
 */
@Composable
fun BusinessDetailRoute(
    businessId: String,
    onBack: () -> Unit,
    onShare: () -> Unit,
    onChat: () -> Unit,
    onWriteReview: () -> Unit,
    onViewAllReviews: () -> Unit,
    onViewAllPhotos: () -> Unit,
    onReport: () -> Unit,
    onRequestListing: () -> Unit = {},
    onOpenClaim: () -> Unit = {},
    onRequireSignIn: () -> Unit = {},
    onOpenChannel: () -> Unit = {},
    modifier: Modifier = Modifier,
    // Commerce slots; filled by the shell from :feature:orders (keeps feature isolation).
    // Promotions rail sits mid-page; the full listings grid closes the page.
    promotionsSlot: @Composable () -> Unit = {},
    listingsSlot: @Composable () -> Unit = {},
    viewModel: BusinessDetailViewModel = koinViewModel(parameters = { parametersOf(businessId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    LaunchedEffect(state.claimStatus, state.reportStatus, state.followSignInRequired) {
        if (state.claimStatus == ClaimUiStatus.SignInRequired) {
            viewModel.consumeClaimGate()
            onRequireSignIn()
        }
        if (state.reportStatus == ReportUiStatus.SignInRequired) {
            viewModel.resetReport()
            onRequireSignIn()
        }
        if (state.followSignInRequired) {
            viewModel.consumeFollowGate()
            onRequireSignIn()
        }
    }
    var showReportSheet by remember { mutableStateOf(false) }
    var showListingRequestSheet by remember { mutableStateOf(false) }
    val shareService = koinInject<ShareService>()
    val shareConfig = koinInject<ShareConfig>()
    val shareMessage = state.business?.let { b ->
        stringResource(Res.string.business_share_message, b.name, shareConfig.businessLink(b.id))
    }
    // Call / Directions / Website open via the platform URI handler (tel:, a universal maps URL, https):
    // ACTION_VIEW on Android, UIApplication.openURL on iOS, window.open on web — no per-platform code.
    val uriHandler = LocalUriHandler.current
    val business = state.business
    val reviewNudge by viewModel.reviewNudge.collectAsStateWithLifecycle()
    // Chat needs the feature flag ON and a claimed business (an owner to talk to).
    val features by koinInject<FeatureFlags>().available.collectAsState()
    val chatAvailable = features.chat && business?.ownerUid != null
    BusinessDetailScreen(
        state = state,
        onBack = onBack,
        onShare = {
            shareMessage?.let {
                viewModel.recordMetric(ListingMetric.Share)
                shareService.share(it)
            }
        },
        onSave = viewModel::toggleSave,
        onToggleFollow = viewModel::toggleFollow,
        onCall = business?.phone?.let { phone ->
            {
                viewModel.trackContactAction(AnalyticsEvents.BUSINESS_CALL)
                viewModel.recordMetric(ListingMetric.Call)
                uriHandler.openUri("tel:" + phone.filterPhone())
            }
        },
        // Directions are hidden for address-suppressed (home-based) listings — no exact pin/route.
        onDirections = business?.takeIf { it.showsExactLocation }?.address?.let { address ->
            {
                viewModel.trackContactAction(AnalyticsEvents.BUSINESS_DIRECTIONS)
                viewModel.recordMetric(ListingMetric.Directions)
                uriHandler.openUri(address.mapsUri())
            }
        },
        onChat = if (chatAvailable) {
            {
                viewModel.noteContactAction()
                viewModel.recordMetric(ListingMetric.Chat)
                onChat()
            }
        } else null,
        // Channel rides the same gates as chat: claimed business + chat feature flag.
        onOpenChannel = if (chatAvailable) onOpenChannel else null,
        onWebsite = business?.website?.takeIf { it.isNotBlank() }?.let { url ->
            {
                viewModel.trackContactAction(AnalyticsEvents.BUSINESS_WEBSITE)
                uriHandler.openUri(url.normalizeUrl())
            }
        },
        onWriteReview = onWriteReview,
        onViewAllReviews = onViewAllReviews,
        onViewAllPhotos = onViewAllPhotos,
        onReport = { showReportSheet = true },
        onRequestListing = { showListingRequestSheet = true },
        onRetry = viewModel::retry,
        onRequestClaim = viewModel::requestClaim,
        onOpenClaim = onOpenClaim,
        promotionsSlot = promotionsSlot,
        listingsSlot = listingsSlot,
        reviewNudgeVisible = reviewNudge,
        onDismissReviewNudge = viewModel::dismissReviewNudge,
        modifier = modifier,
    )
    if (showReportSheet) {
        ReportSheet(
            title = stringResource(Res.string.report_sheet_title),
            reasons = listOf(
                ReportReason(stringResource(Res.string.report_reason_incorrect), "incorrect_info"),
                ReportReason(stringResource(Res.string.report_reason_closed), "permanently_closed"),
                ReportReason(stringResource(Res.string.report_reason_offensive), "offensive_content"),
                ReportReason(stringResource(Res.string.report_reason_scam), "scam_or_fraud"),
            ),
            status = state.reportStatus.toReportStatus(),
            sentText = stringResource(Res.string.report_sent),
            failedText = stringResource(Res.string.report_failed),
            submitText = stringResource(Res.string.report_submit),
            doneText = stringResource(Res.string.report_done),
            onSubmit = viewModel::report,
            onDismiss = {
                showReportSheet = false
                viewModel.resetReport()
            },
        )
    }
    if (showListingRequestSheet) {
        ListingRequestSheet(
            status = state.listingRequestStatus,
            onSubmit = { type, message, email -> viewModel.submitListingRequest(type, message, email) },
            onDismiss = {
                showListingRequestSheet = false
                viewModel.resetListingRequest()
            },
        )
    }
}

/** Maps the business VM's report lifecycle to the copy-free DS sheet (sign-in is handled by the route). */
private fun ReportUiStatus.toReportStatus(): ReportStatus = when (this) {
    ReportUiStatus.Sending -> ReportStatus.Sending
    ReportUiStatus.Sent -> ReportStatus.Sent
    ReportUiStatus.Failed -> ReportStatus.Failed
    ReportUiStatus.Idle, ReportUiStatus.SignInRequired -> ReportStatus.Idle
}

/** Keep only dialable characters so `tel:` URIs are well-formed regardless of how the number was typed. */
internal fun String.filterPhone(): String = filter { it.isDigit() || it == '+' || it == '#' || it == '*' }

/** Prefix a bare `example.com` with `https://` so the URI handler treats it as a web address. */
internal fun String.normalizeUrl(): String =
    if (startsWith("http://") || startsWith("https://")) this else "https://$this"

/**
 * A cross-platform Google Maps URL. The query is the FORMATTED ADDRESS whenever one exists — Maps
 * then shows the named place ("4841 Yonge St…"), not a bare "43.76,-79.41" coordinate pair (owner
 * bug report 2026-07-13). Raw coordinates are only the fallback for address-less records. Opens
 * Google Maps where installed and the browser everywhere else.
 */
internal fun Address.mapsUri(): String {
    val query = formatted().ifBlank { if (lat != null && lng != null) "$lat,$lng" else "" }
    return "https://www.google.com/maps/search/?api=1&query=" + query.urlEncode()
}

/** Minimal percent-encoding for the bits that appear in addresses/coordinates (commonMain-safe). */
internal fun String.urlEncode(): String = buildString {
    for (c in this@urlEncode) {
        when (c) {
            in 'a'..'z', in 'A'..'Z', in '0'..'9', '-', '_', '.', '~' -> append(c)
            ' ' -> append("%20")
            else -> for (b in c.toString().encodeToByteArray()) {
                append('%')
                append(((b.toInt() and 0xFF) shr 4).toString(16).uppercase())
                append((b.toInt() and 0x0F).toString(16).uppercase())
            }
        }
    }
}

/**
 * Business detail — Stitch `fc9c2573` (Directory & Community System). Tokens + string resources only.
 * Stateless; driven by [BusinessDetailUiState]. Reviews/photos arrive with later phases.
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
fun BusinessDetailScreen(
    state: BusinessDetailUiState,
    onBack: () -> Unit,
    onShare: () -> Unit,
    onSave: () -> Unit,
    onToggleFollow: () -> Unit = {},
    onChat: (() -> Unit)?,
    onWriteReview: () -> Unit,
    onViewAllReviews: () -> Unit,
    onViewAllPhotos: () -> Unit,
    onReport: () -> Unit,
    onRequestListing: () -> Unit = {},
    onRetry: () -> Unit,
    modifier: Modifier = Modifier,
    onRequestClaim: () -> Unit = {},
    onOpenClaim: () -> Unit = {},
    promotionsSlot: @Composable () -> Unit = {},
    listingsSlot: @Composable () -> Unit = {},
    // Null when the business has no phone / address / website — the action renders disabled.
    onCall: (() -> Unit)? = null,
    onDirections: (() -> Unit)? = null,
    onWebsite: (() -> Unit)? = null,
    /** Null hides the entry (unclaimed business or chat feature off). */
    onOpenChannel: (() -> Unit)? = null,
    /** One-time post-contact "write a review?" card (see BusinessDetailViewModel.reviewNudge). */
    reviewNudgeVisible: Boolean = false,
    onDismissReviewNudge: () -> Unit = {},
) {
    when {
        state.loading -> { LoadingState(modifier = modifier); return }
        state.error -> {
            ErrorState(
                message = stringResource(Res.string.business_error),
                onRetry = onRetry,
                retryLabel = stringResource(Res.string.business_retry),
                modifier = modifier,
            )
            return
        }
    }
    val business = state.business ?: run {
        ErrorState(
            message = stringResource(Res.string.business_empty),
            onRetry = onRetry,
            retryLabel = stringResource(Res.string.business_retry),
            modifier = modifier,
        )
        return
    }
    val lang = AppTheme.language
    val photoUrls = (listOfNotNull(business.coverUrl) + business.photos)
        .filter { it.isNotBlank() }
        .distinct()
    // Which photo the full-screen viewer is open on; null = closed. Transient view state, so it
    // lives here (like scroll state) rather than in the VM.
    var viewerIndex by remember { mutableStateOf<Int?>(null) }
    viewerIndex?.let { index ->
        FullScreenImageViewer(
            imageUrls = photoUrls,
            startIndex = index,
            closeContentDescription = stringResource(Res.string.photo_viewer_close_a11y),
            counterFormat = stringResource(Res.string.photo_viewer_counter),
            imageContentDescription = stringResource(Res.string.business_photo_a11y),
            onDismiss = { viewerIndex = null },
        )
    }

    Column(
        modifier = modifier
            .background(AppTheme.colors.background)
            .appContentWidth(AppTheme.sizes.contentMaxWidth)
            .verticalScroll(rememberScrollState())
            // AFTER verticalScroll = inside the scrolled content: the page end clears the system
            // navigation bar instead of the last section hiding under it (owner bug 2026-07-26).
            .navigationBarsPadding(),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
    ) {
        // Cover with overlaid actions
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .aspectRatio(16f / 10f),
        ) {
            BusinessCover(
                imageUrl = business.coverUrl,
                contentDescription = stringResource(Res.string.business_cover_a11y),
                iconName = categoryIconKey(business.categoryId),
                // No-photo businesses show the illustrated category image on the detail header too
                // (same as the cards), not the flat glyph.
                placeholderImageRes = diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.categoryImageRes(business.categoryId),
                // Headshot listings (lawyers, agents, doctors) were cropped through the face here.
                fitTallImages = true,
                // Tapping the cover opens the full-screen viewer on the first photo (placeholder
                // covers with no photos at all stay inert).
                modifier = if (photoUrls.isEmpty()) Modifier else Modifier.clickable { viewerIndex = 0 },
            )
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .statusBarsPadding()
                    .padding(AppTheme.spacing.md),
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                CoverIcon("arrow_back", stringResource(Res.string.business_back_a11y), onBack)
                Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                    CoverIcon("share", stringResource(Res.string.business_share_a11y), onShare)
                    CoverIcon(
                        iconName = if (state.isSaved) "bookmark_added" else "bookmark",
                        contentDescription = stringResource(
                            if (state.isSaved) Res.string.business_saved_a11y else Res.string.business_save_a11y,
                        ),
                        onClick = onSave,
                    )
                }
            }
        }

        Column(
            modifier = Modifier.padding(horizontal = AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
        ) {
            // Identity + actions card
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.surface, AppTheme.shapes.card)
                    .padding(AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                ) {
                    Box(
                        modifier = Modifier
                            .size(AppTheme.sizes.iconHero)
                            .background(AppTheme.colors.primaryContainer, AppTheme.shapes.tile),
                        contentAlignment = Alignment.Center,
                    ) {
                        Text(
                            text = business.displayName(lang).take(2).uppercase(),
                            style = AppTheme.typography.headlineMd,
                            color = AppTheme.colors.onPrimary,
                        )
                    }
                    Column(modifier = Modifier.weight(1f)) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                        ) {
                            Text(
                                text = business.displayName(lang),
                                style = AppTheme.typography.headlineMd,
                                color = AppTheme.colors.onSurface,
                            )
                            if (business.verified) {
                                VerificationBadge(contentDescription = stringResource(Res.string.business_verified_a11y))
                            }
                            if (business.ownerPro) {
                                StatusBadge(label = stringResource(Res.string.business_pro_badge))
                            }
                        }
                        // Zero-review listings get an invitation, not an off-putting "0.0 (0)" row.
                        if (business.reviewCount == 0) {
                            Text(
                                text = stringResource(Res.string.business_no_reviews_header),
                                style = AppTheme.typography.bodySm,
                                color = AppTheme.colors.onSurfaceVariant,
                                modifier = Modifier.padding(top = AppTheme.spacing.xxs),
                            )
                        } else {
                            RatingStars(
                                rating = business.rating.toFloat(),
                                reviewCount = business.reviewCount,
                                modifier = Modifier.padding(top = AppTheme.spacing.xxs),
                                contentDescription = stringResource(
                                    Res.string.business_rating_a11y,
                                    ratingText(business.rating, lang),
                                    lang.formatCount(business.reviewCount),
                                ),
                            )
                        }
                        Text(
                            text = business.serviceLine(lang),
                            style = AppTheme.typography.bodySm,
                            color = AppTheme.colors.onSurfaceVariant,
                            modifier = Modifier.padding(top = AppTheme.spacing.xxs),
                        )
                        // Community endorsements from "Ask the Mahaleh" answers — for a young
                        // directory this is often the strongest trust signal on the page.
                        if (business.endorsementCount > 0) {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs),
                                modifier = Modifier.padding(top = AppTheme.spacing.xxs),
                            ) {
                                AppIcon(
                                    name = "recommend",
                                    size = AppTheme.sizes.iconSm,
                                    filled = true,
                                    tint = AppTheme.colors.secondary,
                                )
                                Text(
                                    text = pluralStringResource(
                                        Res.plurals.business_endorsements,
                                        business.endorsementCount,
                                        AppTheme.language.formatCount(business.endorsementCount),
                                    ),
                                    style = AppTheme.typography.labelMd,
                                    color = AppTheme.colors.onSurface,
                                )
                            }
                        }
                    }
                }
                DeferredContent(frames = SLOT_DEFER_FRAMES) { ActiveDealsBanner(businessId = business.id) }
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceEvenly,
                ) {
                    ActionButton(
                        "call", stringResource(Res.string.business_action_call),
                        onClick = onCall ?: {}, enabled = onCall != null,
                    )
                    ActionButton(
                        "directions", stringResource(Res.string.business_action_directions),
                        onClick = onDirections ?: {}, enabled = onDirections != null,
                    )
                    ActionButton(
                        "chat", stringResource(Res.string.business_action_chat),
                        onClick = onChat ?: {}, enabled = onChat != null,
                    )
                    ActionButton(
                        "language", stringResource(Res.string.business_action_website),
                        onClick = onWebsite ?: {}, enabled = onWebsite != null,
                    )
                }
                // Follow for updates (distinct from the top-bar save/bookmark).
                AppButton(
                    text = stringResource(
                        if (state.isFollowing) Res.string.business_following else Res.string.business_follow,
                    ),
                    onClick = onToggleFollow,
                    modifier = Modifier.fillMaxWidth(),
                    variant = if (state.isFollowing) AppButtonVariant.Secondary else AppButtonVariant.Primary,
                    leadingIcon = if (state.isFollowing) "check" else "notifications",
                )
                onOpenChannel?.let {
                    AppButton(
                        text = stringResource(Res.string.business_channel),
                        onClick = it,
                        modifier = Modifier.fillMaxWidth(),
                        variant = AppButtonVariant.Secondary,
                        leadingIcon = "campaign",
                    )
                }
            }

            // About
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                SectionHeader(title = stringResource(Res.string.business_section_about))
                Text(
                    text = business.description.resolve(lang),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                )
                InfoRow("location_on", business.displayAddress(), onClick = onDirections)
                if (!business.showsExactLocation) {
                    Text(
                        text = stringResource(Res.string.business_address_approx),
                        style = AppTheme.typography.labelSm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
                business.phone?.let { InfoRow("call", it, onClick = onCall) }
                // Inline map thumbnail — only for listings that expose an exact pin (home-based
                // businesses suppress it). Reuses AppMap (native on iOS/Android, raster on web).
                val lat = business.address.lat
                val lng = business.address.lng
                if (business.showsExactLocation && lat != null && lng != null) {
                    val uriHandler = LocalUriHandler.current
                    val mapCenter = remember(business.id) { MapPoint(lat, lng) }
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(AppTheme.sizes.chartHeight)
                            .clip(AppTheme.shapes.card),
                    ) {
                        // The embedded map is the most expensive thing on the page (a native
                        // MapView + Play Services init). Paint the page first; the map lands a
                        // few frames later behind a same-size pin placeholder (2026-09-11 perf).
                        DeferredContent(
                            frames = MAP_DEFER_FRAMES,
                            placeholder = {
                                Box(
                                    modifier = Modifier.matchParentSize().background(AppTheme.colors.categoryChip),
                                    contentAlignment = Alignment.Center,
                                ) {
                                    AppIcon(name = "location_on", size = AppTheme.sizes.iconLg, tint = AppTheme.colors.primary)
                                }
                            },
                        ) {
                            AppMap(
                                center = mapCenter,
                                zoom = 15.0,
                                onCameraChange = { _, _ -> },
                                pins = listOf(MapPin(id = business.id, lat = lat, lng = lng, selected = true)),
                                onPinClick = {},
                                attribution = stringResource(Res.string.map_attribution),
                                pinContentDescription = business.displayName(lang),
                                interactive = false,
                                modifier = Modifier.matchParentSize(),
                            )
                        }
                        // Static thumbnail: the overlay consumes the gesture so the embedded map can't
                        // pan (it was stealing the page's vertical scroll — a trap); a tap opens
                        // external directions. Scroll the page by dragging outside this 180dp block.
                        Box(
                            modifier = Modifier
                                .matchParentSize()
                                .pointerInput(business.id) {
                                    awaitEachGesture {
                                        val down = awaitFirstDown()
                                        down.consume()
                                        waitForUpOrCancellation()?.let {
                                            it.consume()
                                            uriHandler.openUri(business.address.mapsUri())
                                        }
                                    }
                                },
                        )
                    }
                }
            }

            // Hours — reuses the same open-status logic that powers the list cards.
            val weeklyHours = rememberWeeklyHours(business)
            if (weeklyHours.isNotEmpty()) {
                Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                    SectionHeader(title = stringResource(Res.string.business_section_hours))
                    rememberOpenStatus(business)?.let { status ->
                        Row(
                            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Text(
                                text = status.label,
                                style = AppTheme.typography.labelMd,
                                color = if (status.isOpen) AppTheme.colors.success else AppTheme.colors.alert,
                            )
                            Text(
                                text = "· ${status.detail}",
                                style = AppTheme.typography.bodySm,
                                color = AppTheme.colors.onSurfaceVariant,
                            )
                        }
                    }
                    weeklyHours.forEach { row ->
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                        ) {
                            Text(
                                text = row.day,
                                style = if (row.isToday) AppTheme.typography.labelMd else AppTheme.typography.bodyMd,
                                color = AppTheme.colors.onSurface,
                            )
                            Text(
                                text = row.hours,
                                style = if (row.isToday) AppTheme.typography.labelMd else AppTheme.typography.bodyMd,
                                color = AppTheme.colors.onSurfaceVariant,
                            )
                        }
                    }
                }
            }

            // Amenities: spoken languages + the category-scoped structured facts the owner
            // enabled (BusinessAttributeRegistry — halal, accepting new patients, virtual tours…).
            val attributeDefs = BusinessAttributeRegistry.resolve(business.categoryId, business.attributes)
            if (business.languagesSpoken.isNotEmpty() || attributeDefs.isNotEmpty()) {
                Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                    SectionHeader(title = stringResource(Res.string.business_section_amenities))
                    FlowRow(
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                    ) {
                        // Localize the known language tokens (owner direction 2026-07-12): raw
                        // "Farsi" must read as "Persian" in EN / «فارسی» in FA; unknown values
                        // (e.g. "Spanish") pass through unchanged.
                        business.languagesSpoken.forEach { item ->
                            AppChip(label = spokenLanguageLabel(item))
                        }
                        attributeDefs.forEach { def ->
                            AppChip(label = def.label.resolve(AppTheme.language))
                        }
                    }
                }
            }

            // Photos — hidden entirely when the listing has none (was showing four fake gray
            // placeholder squares + a "See all" that led to an empty screen).
            if (photoUrls.isNotEmpty()) {
                Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                    SectionHeader(
                        title = stringResource(Res.string.business_section_photos),
                        actionLabel = stringResource(Res.string.business_action_see_all),
                        onAction = onViewAllPhotos,
                    )
                    val tile = AppTheme.sizes.featuredCardWidth.div(2f)
                    DeferredContent(
                        placeholder = {
                            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                                repeat(minOf(photoUrls.size, PHOTO_SKELETON_TILES)) {
                                    Box(
                                        modifier = Modifier
                                            .size(tile)
                                            .clip(AppTheme.shapes.card)
                                            .background(AppTheme.colors.surfaceContainer),
                                    )
                                }
                            }
                        },
                    ) {
                        LazyRow(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                            itemsIndexed(photoUrls, key = { _, url -> url }) { index, url ->
                                BusinessCover(
                                    imageUrl = url,
                                    contentDescription = stringResource(Res.string.business_photo_a11y),
                                    modifier = Modifier
                                        .size(tile)
                                        .clip(AppTheme.shapes.card)
                                        .clickable { viewerIndex = index },
                                )
                            }
                        }
                    }
                }
            }

            // Claim card — unclaimed directory candidates only. The CTA opens the verification claim
            // screen (role + contact + how-to-verify), submitted for admin approval. VERIFIED
            // listings are excluded (owner rule 2026-07-26): a verified badge means identity was
            // already checked, so re-claiming goes through the admin email process with fresh
            // documents — the in-app card flips to that instruction instead of the claim CTA.
            val unclaimed = state.business?.ownerUid == null &&
                state.business?.claimStatus == ClaimStatus.Unclaimed
            val claimable = unclaimed && state.business?.verified != true
            if (claimable) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.card)
                        .padding(AppTheme.spacing.lg),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    Text(
                        text = stringResource(Res.string.business_claim_title),
                        style = AppTheme.typography.bodyLg,
                        color = AppTheme.colors.onSurface,
                    )
                    Text(
                        text = stringResource(Res.string.business_claim_desc),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                    AppButton(
                        text = stringResource(Res.string.business_claim_cta),
                        onClick = onOpenClaim,
                        modifier = Modifier.fillMaxWidth(),
                        variant = AppButtonVariant.Secondary,
                        leadingIcon = "verified_user",
                    )
                }
            } else if (unclaimed) {
                // Verified + unclaimed: point owners at the admin re-verification channel.
                val uriHandler = LocalUriHandler.current
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.card)
                        .padding(AppTheme.spacing.lg),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    Text(
                        text = stringResource(Res.string.business_claim_verified_title),
                        style = AppTheme.typography.bodyLg,
                        color = AppTheme.colors.onSurface,
                    )
                    Text(
                        text = stringResource(Res.string.business_claim_verified_desc),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                    AppButton(
                        text = stringResource(Res.string.business_claim_verified_cta),
                        onClick = { runCatching { uriHandler.openUri("mailto:$CLAIM_SUPPORT_EMAIL") } }, // no mail app installed = no-op, not a crash
                        modifier = Modifier.fillMaxWidth(),
                        variant = AppButtonVariant.Secondary,
                        leadingIcon = "mail",
                    )
                }
            }

            // Promoted products rail (filled by the shell from :feature:orders when any are promoted).
            DeferredContent(frames = SLOT_DEFER_FRAMES) { promotionsSlot() }

            // Review nudge — shown once per business after a contact action (call/directions/chat):
            // the closest signal to "actually visited" we have, and the engine of review density.
            // Owners never see review CTAs for their own listing (rules also reject self-reviews).
            if (reviewNudgeVisible && !state.isOwnBusiness) {
                AppCard(modifier = Modifier.fillMaxWidth()) {
                    Column(
                        modifier = Modifier.padding(AppTheme.spacing.lg),
                        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                    ) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Text(
                                text = stringResource(Res.string.business_review_nudge_title),
                                style = AppTheme.typography.headlineMd,
                                color = AppTheme.colors.onSurface,
                                modifier = Modifier.weight(1f),
                            )
                            AppIconButton(
                                iconName = "close",
                                contentDescription = stringResource(Res.string.business_review_nudge_dismiss_a11y),
                                onClick = onDismissReviewNudge,
                            )
                        }
                        Text(
                            text = stringResource(Res.string.business_review_nudge_desc),
                            style = AppTheme.typography.bodySm,
                            color = AppTheme.colors.onSurfaceVariant,
                        )
                        AppButton(
                            text = stringResource(Res.string.business_write_review),
                            onClick = {
                                onDismissReviewNudge()
                                onWriteReview()
                            },
                            modifier = Modifier.fillMaxWidth(),
                            leadingIcon = "rate_review",
                        )
                    }
                }
            }

            // Reviews — live from the reviews collection (visible only, newest first).
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                SectionHeader(
                    title = stringResource(Res.string.business_section_reviews),
                    actionLabel = stringResource(Res.string.business_action_see_all),
                    onAction = onViewAllReviews,
                )
                if (state.reviews.isEmpty()) {
                    Text(
                        text = stringResource(Res.string.business_reviews_empty),
                        style = AppTheme.typography.bodyMd,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                } else {
                    state.reviews.take(3).forEach { review ->
                        ReviewCard(
                            authorName = review.authorName,
                            rating = review.rating.toFloat(),
                            comment = review.comment,
                            ownerReply = review.ownerReply,
                            ownerReplyLabel = stringResource(Res.string.business_owner_reply),
                        )
                    }
                }
            }

            if (!state.isOwnBusiness) {
                AppButton(
                    text = stringResource(Res.string.business_write_review),
                    onClick = onWriteReview,
                    modifier = Modifier.fillMaxWidth(),
                )
            }

            // Full catalog grid — everything the business offers beyond the promoted rail
            // (filled by the shell from :feature:orders). Closes the page per owner direction.
            DeferredContent(frames = SLOT_DEFER_FRAMES) { listingsSlot() }

            Text(
                text = stringResource(Res.string.business_report),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
                textAlign = TextAlign.Center,
                // Full-width, ≥48dp tap target with the text vertically centred inside it (was a
                // bare Text whose hit rect was only the glyph height).
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable(onClick = onReport)
                    .heightIn(min = AppTheme.sizes.minTouchTarget)
                    .wrapContentHeight(Alignment.CenterVertically),
            )
            // No-login privacy path: an owner (or anyone) can ask us to remove/correct this listing.
            Text(
                text = stringResource(Res.string.business_listing_request_link),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable(onClick = onRequestListing)
                    .heightIn(min = AppTheme.sizes.minTouchTarget)
                    .wrapContentHeight(Alignment.CenterVertically)
                    .padding(bottom = AppTheme.spacing.xl),
            )
        }
    }
}

@Composable
private fun CoverIcon(iconName: String, contentDescription: String, onClick: () -> Unit) {
    Box(
        modifier = Modifier
            .size(AppTheme.sizes.minTouchTarget)
            .background(AppTheme.colors.surface, AppTheme.shapes.pill)
            .clickable(onClick = onClick),
        contentAlignment = Alignment.Center,
    ) {
        AppIcon(iconName, size = AppTheme.sizes.iconMd, tint = AppTheme.colors.onSurface, contentDescription = contentDescription)
    }
}

@Composable
private fun InfoRow(iconName: String, text: String, onClick: (() -> Unit)? = null) {
    // QA 2026-09-12: the address and phone read like the buttons above them, so they should act
    // like them — tapping the address opens directions, tapping the number dials. A tappable row
    // gets a full-width, ≥48dp target; a plain one keeps its old tight layout.
    Row(
        modifier = if (onClick == null) {
            Modifier
        } else {
            Modifier
                .fillMaxWidth()
                .clip(AppTheme.shapes.sm)
                .clickable(onClick = onClick)
                .heightIn(min = AppTheme.sizes.minTouchTarget)
        },
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        AppIcon(iconName, size = AppTheme.sizes.iconSm, tint = AppTheme.colors.primary)
        Text(
            text = text,
            style = AppTheme.typography.bodyMd,
            // An actionable row reads in the action colour, like the buttons it mirrors.
            color = if (onClick == null) AppTheme.colors.onSurface else AppTheme.colors.primary,
        )
    }
}

/**
 * Localizes a business's free-text "language spoken" token to the active UI language: the known
 * set (Persian/Farsi, English, French, Arabic) resolves via string resources — English UI shows
 * "Persian", Farsi UI shows «فارسی» — while any other value passes through unchanged.
 */
@androidx.compose.runtime.Composable
private fun spokenLanguageLabel(token: String): String = when (token.trim().lowercase()) {
    // Some imported listings store BCP-47 codes rather than names — map both shapes.
    "fa", "farsi", "persian", "persan", "فارسی" -> stringResource(Res.string.biz_lang_persian)
    "en", "english", "anglais", "انگلیسی" -> stringResource(Res.string.biz_lang_english)
    "fr", "french", "français", "francais", "فرانسوی" -> stringResource(Res.string.biz_lang_french)
    "ar", "arabic", "arabe", "عربی" -> stringResource(Res.string.biz_lang_arabic)
    else -> token
}

/**
 * Live promotions strip on the business page (gold cards, auto-hide when none / feature off).
 * Contained: injects [DealsRepository] itself so the detail screen's long signature stays put.
 */
@Composable
private fun ActiveDealsBanner(businessId: String) {
    val features by koinInject<FeatureFlags>().available.collectAsState()
    if (!features.deals) return
    val repo = koinInject<DealsRepository>()
    val result by remember(businessId) { repo.observeDealsForBusiness(businessId) }
        .collectAsState(initial = DataResult.Success(emptyList()))
    val nowMillis = kotlin.time.Clock.System.now().toEpochMilliseconds()
    val active = (result as? DataResult.Success)?.data.orEmpty().filter { it.isActive(nowMillis) }
    if (active.isEmpty()) return
    Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
        active.forEach { deal ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.secondaryContainer, AppTheme.shapes.card)
                    .padding(AppTheme.spacing.md),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                AppIcon(name = "sell", size = AppTheme.sizes.iconSm, tint = AppTheme.colors.onSecondaryContainer)
                Text(
                    text = deal.title.resolve(AppTheme.language),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.onSecondaryContainer,
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}

/** One-decimal rating in the active language's digits (4.75f → "4.8", Farsi digits in FA). */
internal fun ratingText(rating: Double, lang: Language): String {
    // Double math end-to-end — a Float narrowing flipped .05-boundary rounding (QA round-7).
    val rounded = (rating * 10).roundToInt()
    return lang.localizeDigits("${rounded / 10}.${rounded % 10}")
}

/** Where verified-listing claims go (admin re-verification with fresh documents — owner rule). */
internal const val CLAIM_SUPPORT_EMAIL = "ircanbusinesshub.support@gmail.com"

/** Frames to paint before the embedded map view is created (see DeferredContent). */
private const val MAP_DEFER_FRAMES = 3
/** Frames before the commerce slots / deals banner open their Firestore streams. */
private const val SLOT_DEFER_FRAMES = 3
/** Placeholder tiles shown while the photo strip's images are deferred. */
private const val PHOTO_SKELETON_TILES = 4
